// extracted by mini-css-extract-plugin
export default {"productCarousel":"JZ-z"};